export const news = {
  newsPageTitle: "促销与新闻",
  newsPageSubtitle: "最新促销、锦标赛和更新",
  newsNew: "新",
  newsReadMore: "阅读更多",
  newsLoadMore: "显示更多新闻",
  articleBadgePromo: "促销",
  articleNotFound: "未找到文章",
  articleBackToNews: "返回新闻",
  articleCtaTitle: "准备好了吗？",
  articleCtaSubtitle: "利用此促销活动，立即开始赢取奖励",
  articleCtaPlay: "立即游戏",
  articleCtaMore: "查看更多促销",
  articleRelated: "更多新闻",
  articleViewAll: "查看全部",
};
